import React from 'react';
import leftPanel from '../../images/leftPanel.png';
import { LeftContainer, LeftBackground } from './styles/LayoutStyles';

export const LeftScreen = () => {
  return (
    <LeftContainer role={'left-screen-container'}>
      <LeftBackground src={leftPanel} role={'left-screen-background'} />
    </LeftContainer>
  );
};
